import { createContext, useContext, useMemo, type ReactNode } from "react";
import { PlantLifecycleClient } from "./client";

const ClientContext = createContext<PlantLifecycleClient | undefined>(undefined);

export function ClientProvider({ client, children }: { client?: PlantLifecycleClient; children: ReactNode }): JSX.Element {
  const value = useMemo(() => client ?? new PlantLifecycleClient(), [client]);
  return <ClientContext.Provider value={value}>{children}</ClientContext.Provider>;
}

export function useClient(): PlantLifecycleClient {
  const client = useContext(ClientContext);
  if (!client) throw new Error("useClient must be used inside a ClientProvider.");
  return client;
}
